export const quotationData = [
    {
        uid:'572b69ec-51ea-4082-9655-059f82405146',
        quotationId:'20230429001',
        requestDate: '2023-06-23',
        customerReference: 'PO8891827S',
        customerName:"ABC E-Commerce",
        status: {
            uid:'14dbc54d-595e-4e5e-aa57-94a85bc81b12',
            value:2,
            name:'Cotação Realizada'
        },
        modal:{
            uid:'9f36b4b4-b8ce-48ab-aade-d1c2f0514d5e',
            name: 'Marítimo',
            value:'M',
            icon: 'IoIosBoat'
        },
        operation:{
            uid:'1ac75355-ae02-4c0c-82d5-de47b3131190',
            name:'Importação',
            value: 'I'
        },
        origin:{
            uid:'',
            code: 'CNSHA',
            name: 'Shanghai',
            locationType:{
                uid:'',
                name: 'Porto',
                icon: 'FaAnchor'
            },
            country:{
                uid: '',
                code: 'CHN',
                name: 'China',
                image: 'chn.png'
            }
        },
        destination:{
            uid: '',
            code: 'BRSSZ',
            name: 'Santos',
            locationType:{
                uid: '',
                name: 'Porto',
                icon: 'FaAnchor'
            },
            country:{
                uid:'',
                code:'BRA',
                name:'Brasil',
                image: 'bra.png'
            }
        },
        type:{
            uid:'',
            name: 'FCL'
        },
        containerType:{
            uid:'5b563fa6-7367-412c-b055-cb053ed26121',
            name: 'Dry Box 40'
        },
        containerQuantity: 1,
        incoterms:[{
            uid:'814b86e1-1c36-4aef-9fa1-aa7ee39435b4',
            name:'FOB'
        }],
        loadType:{
            uid:'9fc1edd3-341f-4c59-a8de-a83ccc87a86a',
            name:'Geral'
        },
        amountCurrency: 'USD',
        loadAmount:49000,
        mensalVolume:'',
        comments:'Por favor, realizar a cotação com a rota mais rápida.',
        aditionalServices:[
            {
                uid: '312d8071-aecd-4e86-883e-7b19f4f186f9',
                name: 'Seguro'
            }
        ],
        attachments:[
            {
                fileType:{
                    uid: '',
                    name: 'Packing List',
                    value: 1
                },
                file:{
                    uid: '9365b421-35fa-4817-a7d6-d643e8bd1533',
                    name: 'Packing List.pdf',
                    sizeBytes: 3000,
                    data: []
                }
            },
            {
                fileType: {
                    uid: '',
                    name: 'Invoice',
                    value: 2
                },
                file: {
                    uid:'a4251738-1bf1-4c44-9f5c-76492e8813d7',
                    name: 'Packing List.pdf',
                    sizeBytes: 4900,
                    data:[]
                }
            }
        ],
        quotationResult:{
            internalReference: '2022001',
            freeTime: '7 dias',
            frequence: 'Diário',
            via: 'Direto',
            transitTime: '41 dias',
            comments: 'Próximo navio disponível apenas na próxima semana.',
            otherConditions:'But recently SHA port open quite late, but equipment we need to pick up first for fear that no available equipment, may faced the advance pick up ctnr fee & ctnr detention fee abt usd350/box, (and exact amount shall be at cost),pls noted.',
            currency: 'USD',
            totalAmount: 9065.00,
            attachments:[
                {
                    fileType: {
                        uid: '',
                        name:'PDF',
                        value: 1
                    },
                    file:{
                        uid: 'd3ffa7e0-3115-406b-ac04-e32f6be28f11',
                        name:'Cotação 20230601.pdf',
                        sizeBytes:2800
                    }
                }
            ],
            services:[
                {
                    service: 1,
                    serviceType:{
                        uid: '',
                        name: 'Frete Internacional',
                        value: 1
                    },
                    items:[
                        {
                            item:1,
                            uid: 'ae4f41d4-392c-4191-8ebb-169c55787a1b',
                            description: 'Frete Marítimo container 20DC',
                            currency: 'USD',
                            tax: 8415.00,
                            unit: 'XCNTR'
                        },
                        {
                            item:2,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'Frete Marítimo container 40DC',
                            currency: 'USD',
                            tax: 8615.00,
                            unit: 'XCNTR'
                        },
                    ]
                },
                {
                    service: 2,
                    serviceType:{
                        uid: '',
                        name: 'Custos de Origem',
                        value: 2
                    },
                    items:[
                        {
                            item:1,
                            uid: 'ae4f41d4-392c-4191-8ebb-169c55787a1b',
                            description: 'DOC FREE',
                            currency: 'USD',
                            tax: 195.00,
                            unit: 'xEMBARQUE'
                        },
                        {
                            item:2,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'PICK UP',
                            currency: 'USD',
                            tax: 620.00,
                            unit: 'XCNTR'
                        },
                        {
                            item:3,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'ORIGIN PORT CHARGES',
                            currency: 'USD',
                            tax: 295.00,
                            unit: 'XCNTR'
                        },
                    ]
                },
                {
                    service: 3,
                    serviceType:{
                        uid: '',
                        name: 'Custos de Destino',
                        value: 3
                    },
                    items:[
                        {
                            item:1,
                            uid: 'ae4f41d4-392c-4191-8ebb-169c55787a1b',
                            description: 'CAPATAZIA',
                            currency: 'BRL',
                            tax: 917.00,
                            unit: 'XCNTR'
                        },
                        {
                            item:2,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'BL FEE',
                            currency: 'BRL',
                            tax: 465.00,
                            unit: 'XBL'
                        },
                        {
                            item:3,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'ISPS',
                            currency: 'USD',
                            tax: 24.00,
                            unit: 'XCNTR'
                        },
                        {
                            item:4,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'DROP OFF FEE',
                            currency: 'USD',
                            tax: 24.00,
                            unit: 'XCNTR'
                        },
                        {
                            item:5,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'DAMAGE PROTECTION FEE',
                            currency: 'USD',
                            tax: 35.00,
                            unit: 'XCNTR'
                        },
                        {
                            item:6,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'ISF',
                            currency: 'USD',
                            tax: 50.00,
                            unit: 'XCNTR'
                        },
                        {
                            item:7,
                            uid: '7a5fda5e-f93f-44c4-915c-07bf9f10fb5e',
                            description: 'DESCONSOLIDAÇÃO',
                            currency: 'USD',
                            tax: 100.00,
                            unit: 'XEMBARQUE'
                        },
                    ]
                },
            ]
        },
        history:[
            {
                index: 0,
                type: 'message',
                fromUid: '817d1291-3667-40b6-815d-c41915e9c4b1',
                avatar: null,
                from: 'Cliente 01',
                moment: '2023-06-23T12:07:22',
                message:'Nova cotação solicitada em 02/05/2023'
            },
            {
                index: 1,
                type: 'attachment',
                fromUid: '817d1291-3667-40b6-815d-c41915e9c4b1',
                avatar: null,
                from: 'Cliente 01',
                moment: '2023-06-23T12:07:22',
                message:'Foi anexado um novo arquivo 02/05/2023: Packing List.pdf'
            },
            {
                index: 2,
                type: 'attachment',
                fromUid: '817d1291-3667-40b6-815d-c41915e9c4b1',
                avatar: null,
                from: 'Cliente 01',
                moment: '2023-06-23T12:07:22',
                message:'Foi anexado um novo arquivo 02/05/2023: Invoice.pdf'
            },
            {
                index: 3,
                type: 'statusChanged',
                fromUid: '',
                avatar: null,
                from: 'VSantos',
                moment: '2023-06-23T12:07:22',
                message:'Sua Cotação está em processamento. Assim que finalizado, você será notificado.'
            },
        ]
    },
    // {
    //     uid:'cb3fc1f6-6971-46be-b686-6766a70ffd20',
    //     quotationId:'20230429002',
    //     requestDate: '2023-05-03',
    //     customer:"ABC E-Commerce",
    //     status: {
    //         uid:'14dbc54d-595e-4e5e-aa57-94a85bc81b12',
    //         value:2,
    //         name:'Cotação Realizada'
    //     },
    //     modal:{
    //         uid:'9f36b4b4-b8ce-48ab-aade-d1c2f0514d5e',
    //         name: 'Aéreo',
    //         value: 'A'
    //     },
    //     operation:{
    //         uid:'70303c68-f44b-4902-b9e8-d94dfd42346b',
    //         name:'Exportação',
    //         value: 'E'
    //     },
    //     origin:'CNSHA',
    //     destination:'BRSSZ',
    //     type:{
    //         uid:'',
    //         name: 'FCL'
    //     },
    //     containerType:{
    //         uid:'5b563fa6-7367-412c-b055-cb053ed26121',
    //         name: 'Dry Box 20'
    //     },
    //     containerQuantity: 1,
    //     incoterms:[{
    //         uid:'814b86e1-1c36-4aef-9fa1-aa7ee39435b4',
    //         name:'FOB'
    //     }],
    //     loadType:{
    //         uid:'9fc1edd3-341f-4c59-a8de-a83ccc87a86a',
    //         name:'Geral'
    //     },
    //     loadAmount:49.500,
    //     mensalVolume:'',
    //     comments:'',
    //     aditionalServices:[
    //         {
    //             uid: '312d8071-aecd-4e86-883e-7b19f4f186f9',
    //             name: 'Seguro'
    //         }
    //     ],
    //     attachments:[]
    // }
];